import React from 'react'
import { InputsContainer } from '../../../ui/form'
import { FORM_TEXTS } from '../constants'
import { formatDateInput } from '../../../../utils/formatDate'
import Input from '../../../ui/input'
import { Calendar } from '../../../../assets/icons'
import Select from '../../../ui/select'

const SignUpStep2 = ({
	values,
	errors,
	touched,
	handleChange,
	handleBlur,
	setFieldValue,
	genderOptions,
	documentTypeOptions
}) => (
	<InputsContainer gap={12} mb={16}>
		<Input
			label={FORM_TEXTS.labels.birthDate}
			name="birthDate"
			placeholder={FORM_TEXTS.placeholders.birthDate}
			value={values.birthDate}
			onChange={e => {
				const formatted = formatDateInput(e.target.value)
				setFieldValue('birthDate', formatted)
			}}
			onBlur={handleBlur}
			error={touched.birthDate && errors.birthDate}
			startAdornment={<Calendar />}
			inputMode="numeric"
			pattern="\d*"
			maxLength={10}
			fullWidth
		/>
		<Select
			label={FORM_TEXTS.labels.gender}
			name="gender"
			value={values.gender}
			onChange={e => setFieldValue('gender', e.target?.value || e)}
			options={genderOptions}
			placeholder={FORM_TEXTS.placeholders.gender}
			error={touched.gender && errors.gender}
		/>
		<Select
			label={FORM_TEXTS.labels.documentType}
			name="documentType"
			value={values.documentType}
			onChange={e => setFieldValue('documentType', e.target?.value || e)}
			options={documentTypeOptions}
			placeholder={FORM_TEXTS.placeholders.documentType}
			error={touched.documentType && errors.documentType}
		/>
		<Input
			label={FORM_TEXTS.labels.documentNumber}
			name="documentNumber"
			placeholder={FORM_TEXTS.placeholders.documentNumber}
			value={values.documentNumber}
			onChange={handleChange}
			onBlur={handleBlur}
			error={touched.documentNumber && errors.documentNumber}
			fullWidth
		/>
		<Input
			label={FORM_TEXTS.labels.phoneNumber}
			name="phoneNumber"
			placeholder={FORM_TEXTS.placeholders.phoneNumber}
			value={values.phoneNumber}
			onChange={handleChange}
			onBlur={handleBlur}
			error={touched.phoneNumber && errors.phoneNumber}
			fullWidth
		/>
	</InputsContainer>
)

export default SignUpStep2
